export const hasOmsAdminAccess = account =>
  Boolean(
    account?.isAdmin ||
      account?.TFRAdmin ||
      account?.GREENAdmin ||
      account?.JUSTAdmin,
  )

/** Strict OMS platform admin — excludes TFR/Green/Just brand admins. */
export const isOmsPlatformAdmin = account => Boolean(account?.isAdmin)

export const hasBrandAdminAccess = account =>
  Boolean(account?.TFRAdmin || account?.GREENAdmin || account?.JUSTAdmin)

/**
 * OMS platform admin, or brand admin on a venue matching their brand type.
 * These people get every tick on the venue (same rule as Express).
 */
export const hasFullVenueAdminAccess = (account, venue) => {
  if (!account || !venue) return false

  if (account.isAdmin) return true

  if (account.TFRAdmin && venue.TFRVenue) return true
  if (account.GREENAdmin && venue.GREENVenue) return true
  if (account.JUSTAdmin && venue.JUSTVenue) return true

  return false
}

export const canChangePrimaryOwner = hasFullVenueAdminAccess

const VENUE_ADMIN_ROLE = 'VENUE_ADMIN'

/** OMS admin, a brand admin, or a venue admin of at least one venue. */
export const canManageAnyVenue = account => {
  if (!account) return false
  if (
    account.isAdmin ||
    account.TFRAdmin ||
    account.GREENAdmin ||
    account.JUSTAdmin
  ) {
    return true
  }
  return Object.values(account.venueRoles || {}).includes(VENUE_ADMIN_ROLE)
}
